<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-24 15:12:13
-->
<template>
  <el-drawer
    :title="editVariableId ? '编辑变量' : '新增变量'"
    :visible.sync="visibleTwo"
    @closed="closeThree"
     :size="width<=720?'90%':'500px'"
    :with-header="true"
    class="box"
  >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          :label-width="width<=720?'120px':'110px'"
          class="demo-ruleForm"
        >
         <a-spin :spinning="loadingShow">
              <el-form-item label="所属分组" prop="groupId">
                <el-select v-model="ruleForm.groupId" placeholder="请选择所属分组">
                  <el-option
                    :label="item.groupName"
                    :value="item.id"
                    v-for="(item, index) in grouplist"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="变量名称" prop="variableName">
                <el-input
                  v-model="ruleForm.variableName"
                  placeholder="请输入变量名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="变量类型" prop="variableType">
                <el-select
                  @change="changeType"
                  v-model="ruleForm.variableType"
                  placeholder="请选择变量类型"
                >
                  <el-option label="单行文本" value="0"></el-option>
                  <el-option label="多行文本" value="1"></el-option>
                  <el-option label="图片" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="变量值" prop="variableValue">
                <el-input
                  v-if="ruleForm.variableType == 0"
                  v-model="ruleForm.variableValue"
                  placeholder="请输入单行文本内容"
                ></el-input>
                <el-input
                  v-if="ruleForm.variableType == 1"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  v-model="ruleForm.variableValue"
                >
                </el-input>
                <el-input
                  v-if="ruleForm.variableType == 2"
                  placeholder="图片地址"
                  disabled
                  v-model="ruleForm.variableValue"
                >
                  <template slot="append">
                    <el-upload
                      :show-file-list="false"
                      :before-upload="beforeLogoUpload"
                      action="#"
                      :limit="1"
                      :multiple="false"
                    >
                      <el-button size="small" type="primary">选择图片</el-button>
                    </el-upload>
                  </template>
                </el-input>
              </el-form-item>
            </a-spin>
          <el-form-item v-if="btnShow" class="bottom">
            <div class="form-bottom">
              <el-button
                size="medium"
                @click="resetForm('ruleForm')"
                >取消</el-button
              >
              <el-button
                :loading="loading"
                size="medium"
                type="primary"
                @click="saveVariable('ruleForm')"
                >保存</el-button
              >
            </div>
          </el-form-item>
        </el-form>
  
  </el-drawer>
</template>

<script>
import {
  variableAdd,
  variableGrouplist,
  variableDetail,
  variableUpdate,
} from "./custom_variables.js";
import { message } from "ant-design-vue";
import { uploadImg } from "@/utils/common.js";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
export default {
  data() {
    return {
      ruleForm: {
        variableName: "",
        groupId:undefined,
        variableType: "1",
        variableValue: "",
      },
      rules: {
        variableName: [
          { required: true, message: "请输入变量名称", trigger: "blur" },
        ],
        groupId: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
        variableValue: [
          { required: true, message: "请填写变量值", trigger: "blur" },
        ],
        variableType: [
          { required: true, message: "请选择所属分组", trigger: "change" },
        ],
      },
      grouplist: [],
      logoImg: "",
      loading:false,
      visibleTwo:false,
      loadingShow:false,
      width:'',
      btnShow:true,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editVariableId: {
      default: null,
    },
  },
  mounted() {
    
  },
  watch:{
    visible(val){
      this.visibleTwo = this.visible;
      this.getKeyboardState()
       this.width  = document.documentElement.clientWidth;
                window.onresize = () => {
                    return (() => {
                        this.width  = document.documentElement.clientWidth;
                    })();
                    };
      if(val){
        this.getGrouplist();
        if (this.editVariableId) {
          this.getVariable();
        }else{
          this.ruleForm = {
            variableName: "",
            groupId: "",
            variableType: "1",
            variableValue: "",
          }
        }
      }
    }
  },
  methods: {
    changeType() {
      
    },
    getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    // 图片上传
    beforeLogoUpload(file) {
      if (
        ["image/jpeg", "image/jpg", "image/png", "image/jpg"].indexOf(
          file.type
        ) == -1
      ) {
        message.error("image/jpeg/png/jpg 格式!");
        return;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("大小不能超过2m!");
        return;
      }
      uploadImg(file, "site_setting").then((res) => {
        this.ruleForm.variableValue = res.path;
      });
      return false;
    },
    close() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    // 保存变量
    saveVariable() {
      const _this = this;
      this.loading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.editVariableId) {
            variableUpdate({
              ..._this.ruleForm,
              siteId: sessionStorage.getItem("siteId"),
            }).then((res) => {
               if(res.code == 0){
                 message.success(res.msg);
                  _this.loading = false;
                _this.close();
               }
            });
          } else {
            variableAdd({
              ..._this.ruleForm,
              siteId: sessionStorage.getItem("siteId"),
            }).then((res) => {
              if (res.code == 0) {
                _this.loading = false;
                message.success(res.msg);
                _this.close();
              }
            });
          }
        } else {
            _this.loading = false;
        }
      });
    },
    getGrouplist() {
      const _this = this;
      variableGrouplist({ siteId: sessionStorage.getItem("siteId") }).then(
        (res) => {
          if (res.code == 0) {
            this.grouplist = res.data;
          }
        }
      );
    },
    closeThree(){
      this.$refs.ruleForm.clearValidate();
      this.$emit('closeThree')
    },
    resetForm() {
      this.closeThree();
    },
    getVariable() {
      const _this = this;
      this.loadingShow = true;
      variableDetail({ id: _this.editVariableId }).then((res) => {
        if (res.code == 0) {
          _this.ruleForm = res.data;
          this.ruleForm.variableType = `${this.ruleForm.variableType}`;
        }
        this.loadingShow = false;
      });
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.el-button--primary {
  background: #176de6;
}
</style>